"use client";
import { jsxs as I, jsx as b } from "react/jsx-runtime";
import { feLog as B } from "../../common/helpers/feLog.js";
import { mergeRefs as L } from "../../common/helpers/mergeRefs.js";
import { boxPadding as j } from "../../common/styles/mixins/boxPadding.js";
import { ellipsis as G } from "../../common/styles/mixins/ellipsis.js";
import { focusOutline as _ } from "../../common/styles/mixins/focusOutline.js";
import H from "../card/Card.js";
import { css as t } from "@emotion/react";
import l from "@emotion/styled";
import { COLORS as n } from "../../tokens/colors/Colors.js";
import { FONT_WEIGHTS as T } from "../../tokens/font-weights/FontWeights.js";
import { MOTION_DURATIONS as v } from "../../tokens/motion-durations/MotionDurations.js";
import { MOTION_EASINGS as K } from "../../tokens/motion-easings/MotionEasings.js";
import { SIZES as M } from "../../tokens/sizes/Sizes.js";
import { SPACINGS as h } from "../../tokens/spacings/Spacings.js";
import { forwardRef as z, useState as F, useRef as k, createRef as U } from "react";
const S = z(
  ({ feDefaultSelected: r, feItems: o, feNoScroll: s, feSelected: d, feStretch: p, onClick: $, ...c }, w) => {
    r && d && B(
      "Tabs",
      "Component has both feSelected and feDefaultSelected props set. Tabs must be either controlled or uncontrolled (specify either the feSelected prop, or the feDefaultSelected prop, but not both). Decide between using a controlled or uncontrolled Tabs component and remove one of these props.",
      "error"
    );
    const [f, g] = F(d ?? r ?? 0), { feType: m } = c, N = c.feType === "expanded" && c.feNoBorder, O = c.feType === "expanded" && c.feNoPadding, P = k(null), R = L([P, w]), y = k(o.map(() => U())), C = m === "expanded" ? Z : W;
    function A(a, e) {
      a.preventDefault(), $ && $(a, e), g(e);
    }
    function D(a) {
      var i;
      let e;
      a.key === "ArrowRight" ? e = f === o.length - 1 ? 0 : f + 1 : a.key === "ArrowLeft" && (e = f === 0 ? o.length - 1 : f - 1), e != null && (g(e), (i = y.current[e].current) == null || i.focus());
    }
    return o.forEach((a, e) => {
      a.id === void 0 && (o[e].id = `${e}`);
    }), /* @__PURE__ */ I(
      C,
      {
        ...c,
        "data-comp": "tabs",
        feNoBorder: N,
        feNoPadding: !0,
        feStretch: p,
        ref: R,
        children: [
          /* @__PURE__ */ b(
            q,
            {
              "aria-orientation": "horizontal",
              feStretch: p,
              feType: m,
              role: "tablist",
              children: o.map((a, e) => {
                const { id: i, label: x } = a, u = d != null ? d === e : f === e;
                return /* @__PURE__ */ b(
                  J,
                  {
                    "aria-selected": u,
                    "data-label": x,
                    feType: m,
                    href: `#fe-tabpanel-${i}`,
                    id: `fe-tab-${i}`,
                    onClick: (E) => A(E, e),
                    onKeyDown: D,
                    ref: y.current[e],
                    role: "tab",
                    stSelected: u,
                    tabIndex: u ? 0 : -1,
                    children: /* @__PURE__ */ b(Q, { children: x })
                  },
                  `fe-tab-${i}`
                );
              })
            }
          ),
          /* @__PURE__ */ b(
            V,
            {
              feNoScroll: s,
              feNoPadding: O,
              feStretch: p,
              feType: m,
              tabIndex: 0,
              children: o.map(({ children: a, id: e }, i) => /* @__PURE__ */ b(
                X,
                {
                  "aria-labelledby": `fe-tab-${e}`,
                  feNoScroll: s,
                  feStretch: p,
                  id: `fe-tabpanel-${e}`,
                  role: "tabpanel",
                  stSelected: d != null ? d === i : f === i,
                  children: a
                },
                `fe-tabpanel-${e}-key`
              ))
            }
          )
        ]
      }
    );
  }
);
S.displayName = "Tabs";
const ue = S, W = l.div(
  ({ feStretch: r }) => t`
		background: ${n.white};

		${r && t`
			display: flex;
			flex-direction: column;
			height: 100%;
		`}
	`
), Z = l(H)(
  ({ feStretch: r }) => t`
		border-top-left-radius: 0;
		border-top-right-radius: 0;

		${r && t`
			display: flex;
			flex-direction: column;
		`}
	`
), q = l.div(
  ({ feStretch: r, feType: o }) => t`
		display: flex;

		${o === "compressed" && t`
			gap: ${h.md};
		`}

		${o === "expanded" && t`
			background: ${n.gray050};
			height: ${M.s40};
		`}

		${r && t`
			flex: none;
		`}
	`
), J = l.a(
  ({ feType: r, stSelected: o }) => t`
		color: ${n.black};
		min-width: 0; /* Needed for truncation */
		position: relative;
		text-decoration: none;

		/* Blue border used in both variants */
		&::after {
			background: ${n.brand};
			content: '';
			height: 3px;
			left: 50%;
			opacity: 0;
			position: absolute;
			right: 50%;
			transition: all ${v.fast}ms ease-in;
		}

		&:focus-visible {
			${_()}
		}

		${o && t`
			color: ${n.brand};
			font-weight: ${T.bold};

			&::after {
				left: 0;
				opacity: 1;
				right: 0;
			}
		`}

		${r === "expanded" && t`
			align-items: center;
			border-bottom: 1px solid ${n.gray300};
			display: inline-flex;
			flex: 1;
			justify-content: center;
			padding: 0 ${h.xs};
			transition: background ${v.fast}ms ${K.easeIn};

			&::after {
				top: 0;
			}

			&:hover,
			&:active {
				background: ${n.primary200};
			}

			&:focus-visible {
				outline-offset: -2px;
			}

			${o && t`
				background: ${n.white};
				border-bottom-color: transparent;
				border-left: 1px solid ${n.gray300};
				border-right: 1px solid ${n.gray300};

				&:first-of-type {
					border-left: 0;
				}

				&:last-of-type {
					border-right: 0;
				}

				&:hover,
				&:active {
					background: ${n.white};
				}
			`}
		`}

		${r === "compressed" && t`
			padding: 0 0 ${h.xxs};

			/* Invisible bold label copy, to avoid layout shifts when selected */
			&::before {
				content: attr(data-label);
				display: block;
				font-weight: ${T.bold};
				height: 0;
				visibility: hidden;
			}

			&::after {
				bottom: 0;
			}

			&:hover,
			&:active {
				&::after {
					left: 0;
					opacity: 1;
					right: 0;
				}
			}
		`}
	`
), Q = l.span`
	${G("x")};
`, V = l.div(
  ({
    feNoScroll: r,
    feNoPadding: o = !1,
    feStretch: s,
    feType: d
  }) => t`
			${j((d === "expanded" ? o : !0) && "block-start")};

			${s && t`
				flex: auto;
				overflow-y: ${r ? "hidden" : "auto"};
			`}
		`
), X = l.div(
  ({
    feNoScroll: r,
    feStretch: o,
    stSelected: s
  }) => t`
		display: ${s ? "block" : "none"};
		height: ${o && r && "100%"};
	`
);
export {
  ue as default
};
